import type { SocialOpportunityItem } from '@inference.engine/widgets/web';

export function createOpportunitySummary(opportunity: SocialOpportunityItem) {
  return {
    opportunityId: opportunity.opportunityId,
    opportunityTitle: opportunity.opportunityTitle,
    opportunityDescription: opportunity.opportunityDescription,
    trendTitle: opportunity.trendTitle,
    trendDescription: opportunity.trendDescription,
    trendInsight: opportunity.trendInsight,
    targetAudience: opportunity.targetAudience,
    targetAudienceProfiles: opportunity.targetAudienceProfiles,
    actionableInsights: opportunity.actionableInsights,
    brandInfo: opportunity.brandInfo,
    engagement: opportunity.engagement,
    priorityReasoning: opportunity.priorityReasoning,
  };
}
